const GermanFlag = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1747_76916)">
                <path d="M15.9238 345.044C52.0948 442.528 145.93 512.001 256.001 512.001C366.072 512.001 459.907 442.528 496.078 345.044L256.001 322.784L15.9238 345.044Z" fill="#FFDA44" />
                <path d="M256.001 0.000976562C145.93 0.000976562 52.0948 69.473 15.9238 166.958L256.001 189.218L496.078 166.957C459.907 69.473 366.072 0.000976562 256.001 0.000976562Z" fill="black" />
                <path d="M15.923 166.958C5.633 194.691 0 224.687 0 256.001C0 287.315 5.633 317.311 15.923 345.044H496.078C506.368 317.311 512 287.315 512 256.001C512 224.687 506.368 194.691 496.077 166.958H15.923Z" fill="#D80027" />
            </g>
            <defs>
                <clipPath id="clip0_1747_76916">
                    <rect width="512" height="512" fill="white" transform="translate(0 0.000976562)" />
                </clipPath>
            </defs>
        </svg>



    )
}
export default GermanFlag